export default __webpack_public_path__ + "static/media/nft.b4334695.svg";